import { observer } from "mobx-react-lite";
import { VStack } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useStores } from "../../store/store_context";

const ModalSelectCompanies = observer(() => {
  const { pageStore } = useStores();
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0, width: 300 });

  // ✅ Получаем массив из строки стора (если пусто — пустой массив)
  const selectedValues = pageStore.select_one_company 
    ? pageStore.select_one_company.split("|") 
    : [];

  useEffect(() => {
    // При монтировании можно сбросить, если это необходимо по логике
    pageStore.updateSelectedCompany("");
  }, [pageStore]);

  useEffect(() => {
    if (isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPos({
        top: rect.bottom + window.scrollY + 5,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuRef.current && !menuRef.current.contains(e.target) &&
        buttonRef.current && !buttonRef.current.contains(e.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleSelect = () => setIsOpen((prev) => !prev);

  // ✅ Логика выбора теперь пишет напрямую в стор
  const handleSelect = (value) => {
    let updatedValues = [...selectedValues];
    if (updatedValues.includes(value)) {
      updatedValues = updatedValues.filter((v) => v !== value);
    } else {
      updatedValues.push(value);
    }
    pageStore.updateSelectedCompany(updatedValues.join("|"));
  };

  // ✅ Выбор всех компаний через стор
  const handleSelectAll = () => {
    const allValues = pageStore.all_companies.map(
      (item) => item?.UF_CRM_580D99FA1DC2F
    );
    
    if (selectedValues.length === allValues.length) {
      pageStore.updateSelectedCompany("");
    } else {
      pageStore.updateSelectedCompany(allValues.join("|"));
    }
  };

  const button = (
    <div
      ref={buttonRef}
      onClick={toggleSelect}
      style={{
        border: "none",
        background: "rgba(51,51,51,1)",
        color: "#EEEEEE",
        borderRadius: "10px",
        fontWeight: 600,
        fontSize: "16px",
        width: "300px",
        padding: "8px",
        cursor: "pointer",
        textAlign: "left",
      }}
    >
      {selectedValues.length > 0 ? `Выбрано: ${selectedValues.length}` : "Не выбрано"}
    </div>
  );

  const menu =
    isOpen &&
    ReactDOM.createPortal(
      <div
        ref={menuRef}
        style={{
          position: "absolute",
          top: `${menuPos.top}px`,
          left: `${menuPos.left}px`,
          background: "#0C0C0C",
          borderRadius: "10px",
          width: `${menuPos.width}px`,
          zIndex: 10000,
          boxShadow: "0 4px 10px rgba(0,0,0,0.5)",
          overflowY: "auto",
          maxHeight: "300px",
        }}
      >
        <div
          onClick={handleSelectAll}
          style={{
            padding: "8px",
            cursor: "pointer",
            background: "#1A1A1A",
            color: "#00FF88",
            fontWeight: "bold",
            textAlign: "center",
            borderBottom: "1px solid #333",
          }}
        >
          {selectedValues.length === pageStore.all_companies.length
            ? "Сбросить выбор"
            : "Выбрать все"}
        </div>

        {pageStore.all_companies.map((item, index) => {
          const value = item?.UF_CRM_580D99FA1DC2F;
          const isSelected = selectedValues.includes(value);
          return (
            <div
              key={index}
              onClick={() => handleSelect(value)}
              style={{
                padding: "6px 8px",
                cursor: "pointer",
                fontSize: "16px",
                background: isSelected ? "#1E1E1E" : "#0C0C0C",
                color: "#EEEEEE",
                fontWeight: isSelected ? "bold" : "normal",
              }}
            >
              {isSelected ? "✓ " : ""}{value}
            </div>
          );
        })}
      </div>,
      document.body
    );

  return (
    <>
      <VStack align="start" position="relative" width="300px">
        {button}
      </VStack>
      {menu}
    </>
  );
});

export default ModalSelectCompanies;